import React, { Component } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import styles from './QuestionsliderStyle';
import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { connect } from 'react-redux';
import contentActions from '../../actions/contentActions';
import { bindActionCreators } from 'redux';

interface QuestionSliderProps extends WithStyles<typeof styles> {
    classes: any,
    totalQuestion: any,
    setQuestionActive: Function,
    isQuestionUpdated: any,
    activeIndex: any,
}

interface QuestionSliderState {
    allQuestionsDropDown: boolean;
}

const slidesToShow = 12;
class QuestionSlider extends Component<QuestionSliderProps, QuestionSliderState>{
    sliderRef: any;
    constructor(props: QuestionSliderProps) {
        super(props);
        this.state = {
            allQuestionsDropDown: false,
        }
        this.showDropDown = this.showDropDown.bind(this)
        //@ts-ignore
        this.sliderRef = React.createRef();
    }

    showDropDown() {
        this.setState({ allQuestionsDropDown: !this.state.allQuestionsDropDown })
    }

    setQuestionActive(index: number) {
        this.setState({ allQuestionsDropDown: false })
        this.props.setQuestionActive(index + 1)
    }
    updateSlideQuestion(index: any) {
        this.sliderRef.current.slickGoTo(index)
        this.props.setQuestionActive(index + 1)
    }

    render() {
        const { classes, totalQuestion, activeIndex } = this.props;
        const { allQuestionsDropDown } = this.state;
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow,
            slidesToScroll: slidesToShow,
            focusOnSelect: true,
            draggable: false,
            prevArrow: <button type='button'></button>,
            nextArrow: <button type='button'></button>,
        };
        return (
            <div className={classes.questionCarousel}>
                <div className={classes.questionSlideSec}>
                    <Slider ref={this.sliderRef} {...settings}>
                        {_.map(totalQuestion, (data: any, index: number) => {
                            return (
                                <span className={`item ${data.active ? 'filled' : ''} ${index + 1 === activeIndex ? 'current' : ''}`} key={index} onClick={() => this.setQuestionActive(index)}>{index + 1}</span>
                            )
                        }
                        )}
                    </Slider>
                </div>

                <div className={classes.questionDropdownGroup}>
                    <button type="button" className={classes.questionDropdown} onClick={this.showDropDown}><span></span><span></span><span></span></button>
                    {
                        allQuestionsDropDown ?
                            <div className={classes.questionDropdownMenu}>
                                <img className="dropdownarrow" src='/assets/svg/dropdown-arrow-ic.svg' alt='Dropdown Arrow' />
                                <h6>Select Questions</h6>
                                <ul className="listing">
                                    {
                                        _.map(totalQuestion, (c, index) => (
                                            <li className={`${c.active ? 'filled' : ''} ${index + 1 === activeIndex ? 'current' : ''}`} key={c._id} onClick={() => this.updateSlideQuestion(index)}>{index + 1}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                            : ''
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        isQuestionUpdated: _.get(state, "mylibraryData.content.isQuestionUpdated", false),
    }
};
// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(QuestionSlider));
